module.exports = __webpack_public_path__ + "static/media/phone.14698f57.svg";